import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";
import PDFViewerImage14 from "../../../../assets/PDFViewerImages/PDFViewerImage14.jpg";
import PDFViewerImage15 from "../../../../assets/PDFViewerImages/PDFViewerImage15.jpg";
import PDFViewerImage16 from "../../../../assets/PDFViewerImages/PDFViewerImage16.jpg";
import PDFViewerImage17 from "../../../../assets/PDFViewerImages/PDFViewerImage17.jpg";
import PDFViewerImage18 from "../../../../assets/PDFViewerImages/PDFViewerImage18.jpg";
import PDFViewerImage19 from "../../../../assets/PDFViewerImages/PDFViewerImage19.jpg";
import PDFViewerImage20 from "../../../../assets/PDFViewerImages/PDFViewerImage20.jpg";
import PDFViewerImage21 from "../../../../assets/PDFViewerImages/PDFViewerImage21.jpg";
import PDFViewerImage22 from "../../../../assets/PDFViewerImages/PDFViewerImage22.jpg";

const Chapter14 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);

    return (
        <>

              {/* Chapter 14 */}
                <section id="section14" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">
                       {language.chapter14Title}
                    </h2>

                    <p className="drivers-handbook-paragraph">
                         {language.chapter14Paragraph1}

                    </p>
                    
                    <p className="drivers-handbook-paragraph">
                         {language.chapter14Paragraph2}

                    </p>
                    <h3 className="drivers-handbook-subheading"> {language.chapter14Subheading1}</h3>

                    <div className="image-box">
                        <img src={PDFViewerImage14} alt="Traffic Rules"/>
                    </div>


                    <h3 className="drivers-handbook-subheading">{language.chapter14Subheading2}</h3>


                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph30}

                    </p>


                    <div className="image-box">
                        <img src={PDFViewerImage15} alt="Traffic Rules"/>
                    </div>


                    <h3 className="drivers-handbook-subheading">{language.chapter14Subheading3}</h3>


                    <p className="drivers-handbook-paragraph">
                         {language.chapter14Paragraph3}

                    </p>
                    <p className="drivers-handbook-paragraph">
                         {language.chapter14Paragraph4}


                    </p>
                    <div className="image-box">
                        <img src={PDFViewerImage16} alt="Traffic Rules"/>
                    </div>

                    <h3 className="drivers-handbook-subheading">{language.chapter14Subheading4}</h3>


                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph5}

                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph6}

                        <div className="image-box">
                            <img src={PDFViewerImage17} alt="Traffic Rules"/>
                        </div>

                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph13b}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph14b}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph15b}
                    </p>


                    <h3 className="drivers-handbook-subheading">{language.chapter14Subheading5}</h3>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph16b}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph7}

                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph8}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph9}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage18} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph10}

                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph11}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph17b}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph18b}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph19b}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph20b}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage19} alt="Traffic Rules"/>
                    </div>


                    <div className="image-box">
                        <img src={PDFViewerImage20} alt="Traffic Rules"/>
                    </div>

                    <div className="image-box">
                        <img src={PDFViewerImage21} alt="Traffic Rules"/>
                    </div>


                    <h3 className="drivers-handbook-subheading">{language.chapter14Subheading5}</h3>

                    <ul className="drivers-handbook-list">
                        <li>{language.chapter14List11}</li>
                        <li>{language.chapter14List12}</li>
                        <li>{language.chapter14List13}</li>
                        <li>{language.chapter14List14}</li>
                        <li>{language.chapter14List15}</li>
                        <li>{language.chapter14List16}</li>
                    </ul>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph25}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage22} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph13}
                    </p>
                    <h3 className="drivers-handbook-subheading">{language.chapter14Subheading7}</h3>


                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph14}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph15}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph16}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph17}
                    </p>
                    <p className="drivers-handbook-paragraph">
                       {language.chapter14Paragraph18}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph19}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph20}

                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph21}
                    </p>
                    <h3 className="drivers-handbook-subheading">{language.chapter14Subheading8}</h3>
                    <ul className="drivers-handbook-list">
                        <li>{language.chapter14List21}</li>
                        <li>{language.chapter14List22}</li>
                        <li>{language.chapter14List23}</li>
                        <li>{language.chapter14List24}</li>
                        <li>{language.chapter14List25}</li>
                        <li>{language.chapter14List26}</li>
                    </ul>

                    <h3 className="drivers-handbook-subheading">{language.chapter14Subheading9}</h3>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph22}

                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph23}

                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter14Paragraph24}
                    </p>

                </section>

        </>
    )

}

export default Chapter14;
